import { Form as Form$1 } from '@sketch/components';
import styled from 'styled-components';

const Form = styled(Form$1) `
  width: 100%;
  max-width: 410px;
`;

export { Form };
